import { render } from "./OdometerWrapper.vue?vue&type=template&id=2215d21e"
import script from "./OdometerWrapper.vue?vue&type=script&lang=js"
export * from "./OdometerWrapper.vue?vue&type=script&lang=js"

import "./OdometerWrapper.vue?vue&type=style&index=0&id=2215d21e&lang=css"
script.render = render

export default script